import simpleModal from "../libs/simpleModal";

const getContent = function (url) {
    const cacheId = Date.now() / 100000000|0;
    const items = [
        {
            url: `javascript:window.fl.social.pageShare('linkedin', '${url}');`,
            label: translate.share.linkedIn,
            icon: 'linkedin',
        },
        {
            url: `javascript:window.fl.social.pageShare('twitter', '${url}');`,
            label: translate.share.twitter,
            icon: 'x',
        },
        {
            url: `javascript:window.fl.social.pageShare('facebook', '${url}');`,
            label: translate.share.facebook,
            icon: 'facebook',
        },
        {
            url: `javascript:window.fl.social.pageShare('whatsapp', '${url}');`,
            label: translate.share.whatsapp,
            icon: 'whatsapp',
        },
        {
            url: `javascript:window.fl.social.pageShare('copy-url', '${url}');`,
            label: translate.share.link,
            icon: 'link',
        },
    ].map(function (v) {
        return `<li>
            <a class="social-link" href="${v.url}" role="button" aria-label="${v.label}" aria-haspopup="true">
                <svg viewBox="0 0 28 28" class="svg-sprite">
                    <title>${v.label}</title>
                    <use xlink:href="/static-icons/svg/social-links.svg?cache=${cacheId}#${v.icon}"></use>
                </svg>
            </a>
    </li>`
    }).join('')
    return `<ul>${items}</ul>`

}

export default function (context) {
    $('#desktopShareButton', context).on('click', function () {
        const modal = new simpleModal({
            id: 'shareButtonsModal',
            content: getContent($(this).data('link')),
            opener: this,
            header: {
                title: window.community.title,
                subtitle: translate.share.subtitle,
            },
        })
        modal.show()
        return false;
    })
}
